/**
 * During gatsby build browser globals are not defined.
 * Avoid referencing browser globals unless on browser check passes
 */
const onBrowser = typeof window !== `undefined`

export default onBrowser
